import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoaderModule } from '®shared/loader';

import { ListEditLegacyRenavComponent } from './list-edit-legacy-renav.component';
import { ListModeResolverComponent } from './list-mode-resolver.component';

@NgModule({
  imports: [CommonModule, LoaderModule, RouterModule],
  declarations: [ListEditLegacyRenavComponent, ListModeResolverComponent],
  exports: [ListEditLegacyRenavComponent, ListModeResolverComponent],
})
export class ListModeResolverModule {}
